<template>
  <div id="app">
    <el-row>
      <!-- <el-col :span="4">
        <Header></Header>
      </el-col> -->
      <el-col :span="24">
        <router-view />
      </el-col>
    </el-row>
    <!-- <Footer></Footer>
    <GoTop></GoTop> -->
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue